<div class="way-component--filterable-container">

  <div class="way-component--header">
    <div class="way-component--header-title">{{"MANAGE_RIGHT_REQUEST" | translate}}</div>
  </div>

  <div class="way-table--main-container">
    <div class="table-container custom-scrollbar">
      <table class="way-table" #table mat-table matSort (matSortChange)="sortData($event)" multiTemplateDataRows
        [dataSource]="dataSource" [attr.aria-label]="'ARIA_RIGHT_REQUEST_TABLE' | translate">
        @for (column of displayedColumns; track column) {
          <ng-container matColumnDef="{{ column }}">
            <th mat-header-cell mat-sort-header [disabled]="column === 'actionColumns' ? true : false"
              *matHeaderCellDef scope="col">
            {{ getRealName(column) }}</th>
            <td mat-cell *matCellDef="let element">
              @if (element) {
                <div>
                  <div>
                    @switch (column) {
                      @case ('level') {
                        @if (element[column] && element[column] !== 'basic') {
                          <mat-chip
                            class="{{element[column]}}">
                            {{ element[column] | translate | uppercase }}
                          </mat-chip>
                        }
                      }
                      @case ('user') {
                        <div>
                          {{element.requesterMail}}
                        </div>
                      }
                      @case ('date') {
                        <div>
                          {{(element.date | typeOf) === 'date' ? (element.date | moment:'L LT') : element.date}}
                        </div>
                      }
                      @case ('actionColumns') {
                        <div class="infos-actionColumns">
                          @if (!element.isLoading) {
                            <button mat-icon-button
                              [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation()">
                              <fa-icon icon="ellipsis-v" class="table--action-icon"></fa-icon>
                            </button>
                          } @else {
                            <span>
                              <mat-progress-spinner color="primary" mode="indeterminate" diameter="16"
                                class="row-loader">
                              </mat-progress-spinner>
                            </span>
                          }
                          <mat-menu #actionMenu="matMenu" xPosition="before">
                            <div class="action-menu">
                              <button mat-menu-item (click)="onClickAcceptDemand(element)">
                                <fa-icon icon="check"
                                [fixedWidth]="true"></fa-icon>
                                {{"MANAGE_RIGHT_ACCEPT" | translate}}
                              </button>
                              <button mat-menu-item class="warn"
                                (click)="onClickRefuseDemand(element)">
                                <fa-icon icon="times"
                                [fixedWidth]="true"></fa-icon>
                                {{"MANAGE_RIGHT_REFUSE" | translate}}
                              </button>
                            </div>
                          </mat-menu>
                          <!-- DropDown -->
                          @if (element.note) {
                            <button mat-icon-button focusable="false">
                              <mat-icon [@rotate180]="isRowExpanded(element) ? 'rotate' : 'void'">expand_more</mat-icon>
                            </button>
                          }
                        </div>
                      }
                      @default {
                        <div>
                          {{ element[column] }}
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </td>
          </ng-container>
        }

        <!-- Expanded details -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell
            *matCellDef="let element"
            style="padding-left:0px; padding-right:0px;"
            [attr.colspan]="displayedColumns.length">
            <div [@detailExpand]="element && isRowExpanded(element) ? 'expanded' : 'collapsed'">
              <div class="additional-data--container">
                @for (expandedCol of expandedColumns; track expandedCol) {
                  <div class="additional-data--main"
                    >
                    <span class="additional-data--title">{{"DIALOG_EDIT_ROLE_COMMENT" | translate}}</span>
                    <span class="additional-data--value"
                      appShowIfTruncated
                    [matTooltip]="element[expandedCol]">{{ element[expandedCol] }}</span>
                  </div>
                }
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky : true"></tr>
        <tr mat-row *matRowDef="let expandedElement; columns: displayedColumns;"
          (click)="switchRowExpansion(expandedElement)" class="general-row"
        [class.expanded-row]="isRowExpanded(expandedElement)"></tr>

        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
      </table>

      @if (isLoadingTable) {
        <div class="table-loader">
          <mat-progress-spinner color="primary" mode="indeterminate" diameter="32">
          </mat-progress-spinner>
        </div>
      }
      @if (isNoData) {
        <div class="no-data">
          <img src="assets/img/undraw_Well_done_re_3hpo.png"
            alt="illustration of well done tasks">
            <span>{{ "MANAGE_RIGHT_NO_REQUESTS" | translate }}</span>
          </div>
        }
      </div>
      <mat-paginator class="way-table--footer" (page)="scrollUp()" [pageSizeOptions]="[25, 50, 100]">
      </mat-paginator>
    </div>

  </div>
